export default __webpack_public_path__ + "static/garden_design4-9685d0a26423a0009141b249a7a872cb.webp";